/* eslint-disable */
import Swal from "sweetalert2";
export const valuationMixin = {
  data() {
    return {
      config: {
        occupancy: [],
        orientation: [],
        condition: [],
        revenue: [],
        block: [],
        unit_location: [],
        first_storey: [],
        space_adding_item: [],
        recess_area: [],
        upgrading: [],
        upgrading_status: [],
        valuation_method: []
      }
    };
  },
  methods: {
    markAsPriority() {
      Swal({
        title: "Are you sure to toggle priority?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          this.valuation.priority = !this.valuation.priority;
          this.$http
            .post(this.rootUrl + "valuation/summary", this.valuation)
            .then(
              res => {
                this.refreshToken(res);
                this.valuation = res.data;
                Swal("Priority updated", "", "success");
              },
              err => {
                this.$snotify.error(err.response.data.message, "Valuation", {
                  timeout: 4000,
                  showProgressBar: false,
                  position: "rightTop"
                });
              }
            );
        }
      });
    },
    extractJSON(json) {
      if (!json) {
        return "";
      }
      let role = "";
      for (const obj in json) {
        if (json.hasOwnProperty(obj)) {
          const element = json[obj];
          if (element && typeof element === "boolean") {
            role = role + ", " + _.startCase(obj);
          } else if (element && typeof element === "string") {
            role = role + ", " + _.startCase(element);
          }
        }
      }

      return role.replace(/(^,)|(,$)/g, "");
    },
    loadTemplates() {
      return this.$http
        .get(this.rootUrl + "report/templates", this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.templates = res.data;
          },
          err => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop"
            });
          }
        );
    },
    userEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=all&text=" + input;
      }
    },
    authHeaders() {
      return {
        Authorization: "Bearer " + this.$parent.token
      };
    },
    formattedCustomerDisplay(result) {
      return result.name + " (" + result.cust_ref_num + ")";
    },
    customerEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "customer/fetch?text=" + input;
      }
    },
    valuerEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=valuer&text=" + input;
      }
    },
    adminEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=admin&text=" + input;
      }
    },
    supervisorEndPoint(input) {
      if (input.length >= 3) {
        return this.rootUrl + "user/fetch?role=supervisor&text=" + input;
      }
    },
    getConfig(type) {
      return this.$http
        .get(this.rootUrl + "config/" + type, this.corsConfig)
        .then(
          res => {
            this.refreshToken(res);
            this.config[type] = res.data;
          },
          err => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop"
            });
          }
        );
    }
  }
};
